import { render, staticRenderFns } from "./NavDetailsItem.vue?vue&type=template&id=ffc7fa56&lang=pug"
import script from "./NavDetailsItem.vue?vue&type=script&lang=js"
export * from "./NavDetailsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports